"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubjectPreferencesSchema = void 0;
const zod_1 = require("zod");
const subject_1 = require("./subject");
const subject_level_1 = require("./subject-level");
const lingo2_models_1 = require("lingo2-models");
exports.SubjectPreferencesSchema = zod_1.z.object({
  subject_id: zod_1.z.number(),
  subject: subject_1.SubjectSchema.optional(),
  level_id: zod_1.z.number(),
  level: subject_level_1.SubjectLevelSchema.optional(),
  filter: zod_1.z.nativeEnum(lingo2_models_1.SubjectFilterEnum)
});
